import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "@/features/auth/auth.slice";
import productsReducer from "@/features/products/products.slice";
import distributorsReducer from "@/features/distributors/distributors.slice";
import purchaseReducer from "@/features/purchase/purchase.slice";
import inventoryReducer from "@/features/inventory/inventory.slice";
import wholesaleReducer from "@/features/wholesale/wholesale.slice";
import activityReducer from "@/features/activity/activity.slice";
import customOrderReducer from "@/features/customerOrder/customOrder.slice";

export const store = configureStore({
  reducer: {
    login: loginReducer,
    products: productsReducer,
    distributors: distributorsReducer,
    purchase: purchaseReducer,
    inventory: inventoryReducer,
    wholesale: wholesaleReducer,
    activity: activityReducer,
    customOrder: customOrderReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
